import { _emLeadsData, _ownLead, _withdrawLead, _changeFaqData, _loadMoreData } from "./types";

import { getBaseUrl, getNestUrl } from "./utility";

import axios from "axios";

const instance = axios.create({
  baseURL: getBaseUrl() + "/",
});

var token = localStorage.getItem("loginToken");

const nestApiInstance = axios.create({
  baseURL: getNestUrl() + "/",
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getLeadData = (user_id) => async (dispatch) => {
  return instance
    .get(`/api/v1/leads/info?user_id=${user_id}&status=&keyword=`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _emLeadsData,
          payload: res.data,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const getLeadDataFilter = (user_id, status, keyword) => async (dispatch) => {
  debugger;
  return instance
    .get(`/api/v1/leads/info?user_id=${user_id}&status=${status}&keyword=${keyword}`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _emLeadsData,
          payload: res.data,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const loadMoreData = (user_id, loadCount, status, keyword) => async (dispatch) => {
  return instance
    .get(
      `/api/v1/leads/info?user_id=${user_id}&page=${loadCount}&status=${status}&keyword${keyword}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _loadMoreData,
          payload: res.data,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const withDrawLead = (user_id, lead_id, demo_userid, courseId) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("user_id", user_id);
  bodyFormData.set("lead_id", lead_id);
  bodyFormData.set("demo_userid", demo_userid);
  bodyFormData.set("course_id", courseId);

  return instance
    .post("/api/v1/user/withdraw/lead", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _withdrawLead,
          payload: lead_id,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const ownLead = (user_id, lead_id) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("user_id", user_id);
  bodyFormData.set("lead_id", lead_id);

  return instance
    .post("/api/v1/user/own/lead", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _ownLead,
          payload: lead_id,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const submitFAQ =
  (agent_Id, demoUser_Id, courseId, demoId, questions) => async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("agent_id", agent_Id);
    bodyFormData.set("demo_userid", demoUser_Id);
    bodyFormData.set("course_id", courseId);
    bodyFormData.set("lead_id", demoId);
    bodyFormData.set("faq_data", JSON.stringify(questions));

    return instance
      .post("/api/v1/user/lead/faqs/add", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const changeFaqData = (data, userId) => async (dispatch) => {
  dispatch({
    type: _changeFaqData,
    payload: data,
    id: userId,
  });
};

export const submitDemoSchedule =
  (studentId, emId, teacherId, courseId, candidateNumber, demoDate, demoTime) =>
  async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("studentId", studentId);
    bodyFormData.set("emId", emId);
    bodyFormData.set("course_id", courseId);
    bodyFormData.set("teacherId", teacherId);
    bodyFormData.set("candidateNumber", candidateNumber);
    bodyFormData.set("demoDate", demoDate);
    bodyFormData.set("demoTime", demoTime);
    bodyFormData.set("client_id", 2);

    return instance
      .post("/api/v1/lead/scheduledemoclass", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const statusQuestionData =
  (
    studentId,
    emId,
    courseId,
    lead_id,
    lead_status,
    demo_status_id,
    demo_status_history,
    videoUrl,
    video_name
  ) =>
  async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("studentId", studentId);
    bodyFormData.set("emId", emId);
    bodyFormData.set("course_id", courseId);
    bodyFormData.set("lead_id", lead_id);
    bodyFormData.set("lead_status_label", lead_status);
    bodyFormData.set("demo_status_id", demo_status_id);
    bodyFormData.set("demo_status_history", demo_status_history);
    bodyFormData.set("video_url", videoUrl);
    bodyFormData.set("video_name", video_name);
    bodyFormData.set("client_id", 2);

    return instance
      .post("/api/v1/lead/statushistoryupdate", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const personalQuestionData = (lead_id, personalQuestion) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("lead_id", lead_id);
  bodyFormData.set("personal_data", personalQuestion);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/lead/updateleadpersonaldata", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const getHistoryData = (lead_id) => async (dispatch) => {
  debugger;
  var bodyFormData = new FormData();
  bodyFormData.set("lead_id", lead_id);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/lead/getleadhistory", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getIncompleteRegistration = (lead_id) => async (dispatch) => {
  debugger;
  var bodyFormData = new FormData();
  bodyFormData.set("lead_id", lead_id);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/lead/incompleteregistrations", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getTeachersPipelineData = () => {
  return instance
    .get("/api/v1/getclassstatistics")
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getAllCourses = () => async (dispatch) => {
  return instance
    .get("api/v1/gradescourses")
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};
export const getAllLeadLogs = (pageNumber) => async (dispatch) => {
  return instance
    .get(`api/v1/leads/logs?page=${pageNumber}`)
    .then((res) => {
      console.log(res);
      debugger;
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
      return res;
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const SendChangeCourse =
  (studentId, emId, courseId, lead_id, order_id) => async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("student_id", studentId);
    bodyFormData.set("EM_id", emId);
    bodyFormData.set("course_id", courseId);
    bodyFormData.set("lead_id", lead_id);
    bodyFormData.set("order_id", order_id);
    bodyFormData.set("client_id", 2);

    return instance
      .post("/api/v1/lead/user/updatedemocourse", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const SendUserName = (studentId, emId, lead_id, username) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("student_id", studentId);
  bodyFormData.set("EM_id", emId);
  bodyFormData.set("lead_id", lead_id);
  bodyFormData.set("username", username);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/lead/user/updateusername", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const SendMessageToAllTutors =
  (courseId, prog_id, emId, lead_id, class_time) => async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("course_id", courseId);
    bodyFormData.set("EM_id", emId);
    bodyFormData.set("lead_id", lead_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("class_time", class_time);
    bodyFormData.set("client_id", 2);

    return instance
      .post("/api/v1/lead/requestteacherdemoclass", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const intrestedTeachers = (leadId) => async (dispatch) => {
  return instance
    .get(`api/v1/lead/getavailableteachersforclass?lead_id=${leadId}`)
    .then((res) => {
      console.log(res);
      debugger;
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
      return res;
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const confirmTutor = (courseId, emId, teacher_id, class_request_id) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("course_id", courseId);
  bodyFormData.set("EM_id", emId);
  bodyFormData.set("teacher_id", teacher_id);
  bodyFormData.set("class_request_id", class_request_id);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/lead/assignteachertointerest", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        //   type: _ownLead,
        //   payload: lead_id,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getAllStudents = (clientId, userName, email, phoneNumber, page, limit) => {
  return nestApiInstance
    .get(
      `/admin/student?client_id=${clientId}&user_name=${userName}&user_email=${email}&user_phonenumber=${phoneNumber}&page=${page}&limit=${limit}`
    )
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentDetails = (clientId, studentId) => {
  return nestApiInstance
    .get(`/admin/student/${studentId}?client_id=${clientId}`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getToken = (userId) => {
  const body = {
    id: userId,
  };
  return nestApiInstance
    .post(`/account/generate-token?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.status === 201) {
        return res;
      } else {
        return res;
      }
    })
    .catch((error) => {});
};

export const updateStudentDetails = (userId) => {
  const body = {
    id: userId,
  };
  return nestApiInstance
    .post(`/account/generate-token?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      if (res.status === 201) {
        return res;
      } else {
        return res;
      }
    })
    .catch((error) => {});
};

export const getAllPrograms = () => {
  return nestApiInstance
    .get(`/admin/course?store_id=1&limit=1000`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentPrograms = (studentId) => {
  return nestApiInstance
    .get(`/admin/student/${studentId}/program?client_id=2&limit=1000`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentInvoices = (studentId) => {
  return nestApiInstance
    .get(`/admin/student/${studentId}/invoice`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentInvoicesStudent = (studentId) => {
  return nestApiInstance
    .get(`/student/${studentId}/invoice`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentInvoiceAggregate = (studentId) => {
  return nestApiInstance
    .get(`/admin/student/${studentId}/invoice/aggregate`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getAllUnpaidInvoice = (studentId) => {
  return nestApiInstance
    .get(`/admin/student/${studentId}/invoice/unpaid`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getAllUnpaidInvoiceStudent = (studentId) => {
  return nestApiInstance
    .get(`/student/${studentId}/invoice/unpaid`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getStudentInvoiceDetail = (invoiceId) => {
  return nestApiInstance
    .get(`/admin/invoice/${invoiceId}`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};
export const getStudentInvoiceDetailStudent = (invoiceId) => {
  return nestApiInstance
    .get(`/invoice/${invoiceId}?client_id=2`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getReferralStudents = () => {
  return nestApiInstance
    .get(`/admin/referral?client_id=2&limit=1000`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getReferralByList = (studentId) => {
  return nestApiInstance
    .get(`/admin/referral?client_id=2&limit=1000&referral=${studentId}`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const sendOTPForPassword = (email, loginName) => {
  const body = {
    user_email: email,
    user_loginname: loginName,
  };
  return nestApiInstance
    .post(`/account/forgot-password?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      if (res.status === 201) {
        return res;
      } else {
        return res;
      }
    })
    .catch((error) => {});
};

export const verifyOTPForPassword = (email, loginName, otpCode) => {
  const body = {
    user_email: email,
    user_loginname: loginName,
    otp_code: otpCode,
  };
  return nestApiInstance
    .post(`/account/forgot-password/done?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      localStorage.setItem("updateToken", res?.data?.accessToken);
      return res;
    })
    .catch((error) => {
      return error.response;
    });
};

export const updatePassword = (password) => {
  const verifyToken = localStorage.getItem("updateToken");
  const body = {
    newPassword: password,
    retypePassword: password,
  };
  return nestApiInstance
    .post(`/account/change-password?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${verifyToken}`,
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      return res;
    })
    .catch((error) => {
      return error.response;
    });
};

export const assignProgram = (studentId, programId, courseId, generateInvoice) => {
  const body = {
    user_id: studentId,
    student_id: studentId,
    prog_id: programId,
    course_id: courseId,

    generateInvoice: generateInvoice,
  };
  return nestApiInstance
    .post(`/admin/student/${studentId}/program`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      if (res.status === 201) {
        return res;
      } else {
        return res;
      }
    })
    .catch((error) => {});
};

export const updateStudentInformation = (studentId, userName, userEmail, phoneNumber) => {
  const body = {
    user_name: userName,
    user_email: userEmail,
    phone: phoneNumber,
  };
  return nestApiInstance
    .patch(`/admin/student/${studentId}?client_id=2`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      debugger;
      console.log(res);
      if (res.status === 201) {
        return res;
      } else {
        return res;
      }
    })
    .catch((error) => {});
};

export const fileUpload = (files, userId, fileUserType,onUploadProgress) => {
  var bodyFormData = new FormData();
  if (Array.isArray(files)) {
    files.map((file) => {
      bodyFormData.append("file", file);
    });
  } else {
    bodyFormData.append("file", files);
  }
  bodyFormData.set("userId", userId);
  bodyFormData.set("fileUserType", fileUserType);

  let res = {};
  return nestApiInstance
    .post("/file/upload/aws", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress) {
          onUploadProgress(progressEvent);
        }
      }
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  // debugger;
  return res;
};

export const fileUploadAfterSignURL = async (url, file,onUploadProgress) => {
  const headersList = {
    Accept: "*/*",
    "Content-Type": file?.type,
  };

  let res = {};

  const reqOptions = {
    url: url,
    method: "PUT",
    headers: headersList,
    data: file,
     onUploadProgress: (progressEvent) => {
      if (onUploadProgress) {
        onUploadProgress(progressEvent);
      }
    }
  };
  const response = await axios(reqOptions);

  return response;
};

export const generateSignUrl = (fileName, userType, fileType, label, userId) => {
  const bodyconfig = {
    filename: fileName,
    fileUserType: userType,
    contentType: fileType,
    label: label,
    userId: userId,
  };

  let res = {};
  return nestApiInstance
    .post("/file/generate-signurl", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
};
export const createFeedMultiple = (
  userId,
  assignId,
  courseId,
  programId,
  teacherId,
  slotId,
  feedLabel,
  feedData,
  shareWith
) => {
  const bodyconfig = {
    user_id: userId,
    assign_id: assignId,
    course_id: courseId,
    prog_id: programId.toString(),
    teacher_id: teacherId,
    slot_id: slotId,
    feed_lebel: feedLabel,
    feed_data: feedData,
    shared_feed_option: shareWith
  };

  let res = {};
  return nestApiInstance
    .post("/feed/userfeed?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  debugger;
  return res;
};
export const createFeed = (
  userId,
  assignId,
  courseId,
  programId,
  teacherId,
  slotId,
  feedLabel,
  message,
  imageUrl,
  urlType
) => {
  const bodyconfig = {
    user_id: userId,
    assign_id: assignId,
    course_id: courseId,
    prog_id: programId.toString(),
    teacher_id: teacherId,
    slot_id: slotId,
    feed_lebel: feedLabel,
    feed_data: {
      message,
      url: imageUrl,
      url_type: urlType,
    },
  };

  let res = {};
  return nestApiInstance
    .post("/feed/userfeed?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  debugger;
  return res;
};
export const teacherUploadHomeWork = (
  userId,
  assignId,
  courseId,
  programId,
  teacherId,
  slotId,
  feedLabel,
  feedGroup,
  message,
  imageUrl,
  urlType
) => {
  const bodyconfig = {
    user_id: userId,
    assign_id: assignId,
    course_id: courseId,
    prog_id: programId.toString(),
    teacher_id: teacherId,
    slot_id: slotId,
    feed_lebel: feedLabel,
    feed_group: feedGroup,
    feed_data: {
      message,
      url: imageUrl,
      url_type: urlType,
    },
  };

  let res = {};
  return nestApiInstance
    .post("/feed/userfeed?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  debugger;
  return res;
};
export const teacherUploadHomeWorkMultiple = (
  userId,
  assignId,
  courseId,
  programId,
  teacherId,
  slotId,
  feedLabel,
  feedGroup,
  feedData
) => {
  const bodyconfig = {
    user_id: userId,
    assign_id: assignId,
    course_id: courseId,
    prog_id: programId.toString(),
    teacher_id: teacherId,
    slot_id: slotId,
    feed_lebel: feedLabel,
    feed_group: feedGroup,
    feed_data: feedData,
  };

  let res = {};
  return nestApiInstance
    .post("/feed/userfeed?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  debugger;
  return res;
};

export const getAllTeacherForms = (limit, page, search, status) => {
  return nestApiInstance
    .get(
      `/admin/teacher/recruitment?client_id=2&limit=${limit}&page=${page}&search=${search}&hide=0&status=${status}`
    )
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const getSingleTeacherForms = (recruitmentId) => {
  return nestApiInstance
    .get(`/admin/teacher/recruitment/${recruitmentId}?client_id=2`)
    .then((res) => {
      console.log(res);

      return res;
    })
    .catch((error) => {});
};

export const generateMultipleSignUrl = (items) => {
  const bodyconfig = {
    items
  };

  let res = {};
  return nestApiInstance
    .post("/file/multi-generate-signurl", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
};

export const teacherUploadFeedMultiple = (
  userId,
  assignId,
  courseId,
  programId,
  teacherId,
  slotId,
  feedLabel,
  feedGroup,
  feedData
) => {
  const bodyconfig = {
    user_id: userId,
    assign_id: assignId,
    course_id: courseId,
    prog_id: programId.toString(),
    teacher_id: teacherId,
    slot_id: slotId,
    feed_lebel: feedLabel,
    feed_group: feedGroup,
    feed_data: feedData,
  };

  let res = {};
  return nestApiInstance
    .post("/teacher/feed?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
  debugger;
  return res;
};

export const updateStudentImage = (data) => {
  const bodyconfig = {
    ...data
  };

  let res = {};
  return nestApiInstance
    .post("/student/profile/image?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
};

export const stripeCharges = (data) => {
  const bodyconfig = {
    ...data
  };

  let res = {};
  return nestApiInstance
    .post("/payment/stripe-charges?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      console.log("Add File : ", response);
      return response;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
};